import type { Breadcrumb } from 'common/types/Breadcrumb';

interface GetBreadcrumbsOptions {
  items: Breadcrumb[];
  isLastInactive: boolean;
  matchesTablet: boolean;
}

export const getBreadcrumbs = ({ items, isLastInactive, matchesTablet }: GetBreadcrumbsOptions) => {
  if (matchesTablet) {
    return items;
  } else if (isLastInactive) {
    return items.slice(-2, -1);
  }

  return items.slice(-1);
};
